export const waermepumpeEignungsAnalyse = [
    {
      "id": 100,
      "type": "radio-step",
      "description":"type of real estate",
      "title": "Das Gebäude ist ein...",
      "options": [
        {  id:"1", value:"Ein- oder Zweifamilienhaus", "next" : 102, "prev" : -1, "options": {"icon":"/libs/wizard/check/svg/one_family_house.svg", "text":"Einfamilienhaus", "size":"s"}},
        {  id:"2", value:"Mehrfamilienhaus", "next" : 102, "prev" : -1, "options": {"icon":"/libs/wizard/check/svg/multifamily_house.svg", "text":"Mehrfamilienhaus", "size":"s"}},
      ]
    },
  
    {
      "id": 102,
      "type": "radio-step",
      "description":"type of real estate",
      "title": "In dem Gebäude läuft eine…",
      "fieldName": "",
      "options": [
        {  id:"2", value:"Zentralheizung", "next" : 103, "prev" : -1, "options": {"icon":"/libs/wizard/check/svg/euro_wenig.svg", "text":"Zentralheizung", "size":"m"}},
        {  id:"1", value:"Nachtspeicherheizung", "next" : 103, "prev" : -1, "options": {"icon":"/libs/wizard/check/svg/euro_mittel.svg", "text":"Nachtspeicherheizung", "size":"m"}},
        
      ]
    },
    {
      "id": 103,
      "type": "cards-step",
      "description":"type of real estate",
      "title": "Grundriss des Gebäudes",
      "fieldName": "",
      "options": [
        {  id:"2", value:"freistehend", "next" : 104, "prev" : -1, "options": {"icon":"/libs/wizard/check/wp/icon-gebaeude_lage_freistehend.svg", "text":"freistehend", "size":"m"}},
        {  id:"1", value:"Reihenmittelhaus", "next" : 104, "prev" : -1, "options": {"icon":"/libs/wizard/check/wp/icon-gebaeude_lage_mitte.svg", "text":"reihenmittelhaus", "size":"m"}},
        {  id:"1", value:"Reihenendhaus", "next" : 104, "prev" : -1, "options": {"icon":"/libs/wizard/check/wp/icon-gebaeude_lage_ecke.svg", "text":"reihenendhaus", "size":"m"}},
        
      ]
    },
    {
      "id": 104,
      "type": "cards-step",
      "description":"type of real estate",
      "title": "Gebäudelage",
      "options": [
        {  id:"2", value:"kompakt", "next" : 105, "prev" : -1, "options": {"icon":"/libs/wizard/check/wp/icon-gebaeude_grundriss_kompakt.svg", "text":"Gering", "size":"m"}},
        {  id:"1", value:"langgestreckt, gewinkelt, komplex", "next" : 105, "prev" : -1, "options": {"icon":"/libs/wizard/check/wp/icon-gebaeude_grundriss_komplex.svg", "text":"Mittel", "size":"m"}},
        
      ]
    },
    {
        "id": 105,
        "type": "slider-step",
        "description":"Apartment Count",
        "title": "Wie viele Stockwerke hat Ihr Gebäude (ohne Keller oder Dachgeschoss)?",
        "fieldName": "Anzahl_Geschosse",
        "options": [
          { id:"0", "next" : 106, "prev" : "nil", "options": {
            "unit": "",
            "range": {
              "min": 1,
              "max": 10
            },
            "default": 1,
            "text":"Anzahl der Geschosse",
            "icon": "",
            "button_title": "Weiter",
            "placeholder" : "Anzahl",
          }
        }
        ]
      },
    {
      "id": 106,
      "type": "input-step",
      "description":"geplant",
      "title": "Gebäudedetails",
      "options": [
        { id:"0", "next" : 107, "prev" : "nil", "button_title": "Next", "options": {
          "default": '',
          "text":"",
          "icon": "/libs/wizard/check/svg/time.svg",
          "button_title": "Weiter",
          "placeholder" : "Baujahr",
          "description": "Aus dem Gebäudebaujahr lassen sich die damals gültigen baurechtlichen Vorschriften ableiten"
        }
      }
      ]
    },
    
    {
      "id": 107,
      "type": "slider-step",
      "description":"Nutzfläche",
      "title": "Wie groß ist die Wohnfläche?",
      "fieldName": "Nutzfläche",
      "options": [
        { id:"0", "next" : 108, "prev" : "nil", "options": {
          "unit": "m<sup>2</sup>",
          "range": {
            "min": 10,
            "max": 500
          },
          "default": 115,
          "text":"Nutzfläche",
          "icon": "/libs/wizard/check/svg/square-size.svg",
          "button_title": "Weiter",
          "placeholder" : "m<sup>2</sup>"
        }
      }
      ]
    },
    {
      "id": 108,
      "type": "cards-step",
      "description":"type of real estate",
      "title": "Welche Form hat das Dach Ihres Gebäudes?",
      "options": [
        {  id:"2", value:"Spitzdach", "next" : 109, "prev" : -1, "options": {"icon":"/libs/wizard/check/wp/icon-gebaeude_dachform_spitzdach.svg", "text":"Spitzdach", "size":"m"}},
        {  id:"1", value:"Flachdach", "next" : 109, "prev" : -1, "options": {"icon":"/libs/wizard/check/wp/icon-gebaeude_dachform_flachdach.svg", "text":"Flachdach", "size":"m"}},
        {  id:"1", value:"Pultdach", "next" : 109, "prev" : -1, "options": {"icon":"/libs/wizard/check/wp/icon-gebaeude_dachform_pultdach.svg", "text":"Pultdach", "size":"m"}},
      ]
    },
    {
      "id": 109,
      "type": "radio-step",
      "description":"type of real estate",
      "title": "Wurde Ihre Fassade nachträglich gedämmt?",
      "options": [
        {  id:"1", value:"unbekannt", "next" : 110, "prev" : -1, "options": {"icon":"", "text":"unbekannt", "size":"m"}},
        {  id:"2", value:"nein, nicht nachträglich gedämmt", "next" : 110, "prev" : -1, "options": {"icon":"", "text":"nein, nicht nachträglich gedämmt", "size":"m"}},
        {  id:"3", value:"ja, nachträglich gedämmt", "next" : 110, "prev" : -1, "options": {"icon":"", "text":"ja, nachträglich gedämmt", "size":"m"}},
      ]
    },
    {
      "id": 110,
      "type": "radio-step",
      "description":"type of real estate",
      "title": "Wurde Ihre Dach nachträglich gedämmt?",
      "options": [
        {  id:"1", value:"unbekannt", "next" : 111, "prev" : -1, "options": {"icon":"", "text":"unbekannt", "size":"m"}},
        {  id:"2", value:"nein, nicht nachträglich gedämmt", "next" : 111, "prev" : -1, "options": {"icon":"", "text":"nein, nicht nachträglich gedämmt", "size":"m"}},
        {  id:"3", value:"ja, nachträglich gedämmt", "next" : 111, "prev" : -1, "options": {"icon":"", "text":"ja, nachträglich gedämmt", "size":"m"}},
      ]
    },
    {
      "id": 111,
      "type": "radio-step",
      "description":"type of real estate",
      "title": "Wurde Ihre Kellerdecke nachträglich gedämmt?",
      "options": [
        {  id:"1", value:"unbekannt", "next" : 112, "prev" : -1, "options": {"icon":"", "text":"unbekannt", "size":"m"}},
        {  id:"2", value:"nein, nicht nachträglich gedämmt", "next" : 112, "prev" : -1, "options": {"icon":"", "text":"nein, nicht nachträglich gedämmt", "size":"m"}},
        {  id:"3", value:"ja, nachträglich gedämmt", "next" : 112, "prev" : -1, "options": {"icon":"", "text":"ja, nachträglich gedämmt", "size":"m"}},
      ]
    },
    {
      "id": 112,
      "type": "cards-step",
      "description":"type of real estate",
      "title": "Fenstertyp",
      "options": [
        {  id:"2", value:"einfachverglaste Fenster", "next" : 998, "prev" : -1, "options": {"icon":"/libs/wizard/check/wp/icon-fenster_verglasungsart_einfach.svg", "text":"einfachverglaste Fenster", "size":"m"}},
        {  id:"1", value:"zweifachverglaste Verbundfenster (luftisoliert)", "next" : 998, "prev" : -1, "options": {"icon":"/libs/wizard/check/wp/icon-fenster_verglasungsart_zweifachverbund.svg", "text":"zweifachverglaste Verbundfenster (luftisoliert)", "size":"m"}},
        {  id:"1", value:"Zweifach-Wärmeschutzverglasung", "next" : 998, "prev" : -1, "options": {"icon":"/libs/wizard/check/wp/icon-fenster_verglasungsart_zweifachwaermeschutz.svg", "text":"Zweifach-Wärmeschutzverglasung", "size":"m"}},
        {  id:"1", value:"Dreifach-Wärmeschutzverglasung", "next" : 998, "prev" : -1, "options": {"icon":"/libs/wizard/check/wp/icon-fenster_verglasungsart_dreifachwaermeschutz.svg", "text":"Dreifach-Wärmeschutzverglasung", "size":"m"}},
        {  id:"1", value:"Unbekannt", "next" : 998, "prev" : -1, "options": {"icon":"/libs/wizard/check/svg/other2.svg", "text":"Unbekannt", "size":"m"}},
      ]
    },
  ]